import { Dialog, DialogContent, Typography } from "@mui/material";

interface PaymentDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function PaymentDialog({ open, onClose }: PaymentDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Typography variant="h6" sx={{ fontFamily: "'Rubik', sans-serif", mb: 2 }}>
          Detalles de Pago
        </Typography>
        <Typography sx={{ fontFamily: "'Rubik', sans-serif" }}>
          Información sobre métodos de pago, cuotas, y otras opciones de financiamiento.
        </Typography>
      </DialogContent>
    </Dialog>
  );
}














